<template>
  <div class="flex xs12">
    <va-card :title="$t('forms.inputs.loadDivergences') + ' ' + $t('tables.loads.code') + ' ' + this.$route.params.loadCode">
      <va-button
        v-if="this.$route.params.assemblyLine == 9"
        medium
        inline
        color="#ff842b"
        icon="fa fa-chevron-left"
        class="ma-2"
        :to="{ name: 'loads', params: {
          current_page: this.$route.params.current_page,
          search: this.$route.params.search,
          delivery_date: this.$route.params.delivery_date,
          perPage: this.$route.params.perPage }
          }"
      >
          {{ $t('menu.back') }}
      </va-button>
      <va-button
        v-if="this.$route.params.assemblyLine == 10"
        medium
        inline
        color="#ff842b"
        icon="fa fa-chevron-left"
        class="ma-2"
        :to="{ name: 'loads_finished', params: {
          current_page: this.$route.params.current_page,
          search: this.$route.params.search,
          delivery_date: this.$route.params.delivery_date,
          perPage: this.$route.params.perPage }
          }"
      >
          {{ $t('menu.back') }}
      </va-button>

      <va-button
        medium
        inline
        color="green"
        icon="fa fa-download"
        class="ma-0"
        @click="exportDivergenceReport()"
      >
        {{ $t('menu.export') }}
      </va-button>

      <va-data-table
        :fields="fields"
        :data="divergenceLoadProducts"
        no-pagination
      />
    </va-card>
  </div>
</template>

<script>

import DivergenceLoadProductAPI from '@/services/DivergenceLoadProductAPI'

export default {
  data () {
    return {
      divergenceLoadProducts: [],
      backAction: this.$route.params.backAction,
      filepath: '',
    }
  },
  mounted () {
    this.getAllDivergenceLoadProducts()
  },
  computed: {
    fields () {
      return [{
        name: 'integration_id',
        title: this.$t('forms.inputs.integrationId'),
      },
      {
        name: 'product',
        title: this.$t('tables.divergenceLoadProducts.product'),
        width: '25%',
      },
      {
        name: 'quantity',
        title: this.$t('tables.divergenceLoadProducts.quantity'),
        width: '25%',
      },
      {
        name: 'missing',
        title: this.$t('tables.divergenceLoadProducts.missing'),
        width: '25%',
      },
      ]
    },
  },
  methods: {
    getAllDivergenceLoadProducts () {
      DivergenceLoadProductAPI.getDivergenceLoadProductsGroupedByLoadId(this.$route.params.loadID).then(response => {
        this.divergenceLoadProducts = response.data.divergence_load_products
      })
    },

    exportDivergenceReport () {
      DivergenceLoadProductAPI.exportDivergenceReport(this.$route.params.loadID).then(response => {
        let url = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '')
        let link = document.createElement('a')
        this.filepath = url + response.data.filename
        link.href = this.filepath
        link.download = response.data.filename
        document.body.appendChild(link)
        link.click()

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },
  },
}
</script>
